import { janooApi } from "./../config";
// import fdata from "./fakedata_muritiba_2022.10.12";
// import fdata from "./fakedata_muritiba_2022.09.21-2022.10.05";
// import fdata from "./fakedata_muritiba_2022.09.01-2022.09.30";
// import fdata from "./fakedata_muritiba_2022.09.19-21";
// import fdata from "./fakedata_muritiba_2022.09.19-25";
// import fdata from "./fakedata_muritiba_2022.09.01-2022.10.31";
// import fdata from "./fakedata_muritiba_2022.09.29";
// import fdata from "./fakedata_muritiba_2022.12.31";
// import fdata from "./fakedata_muritiba_2023.02";
// import fdata from "./fakedata_pncd_2023.02";
// import fdata from "./fakedata_pncd_2021.05.01-2021.06.30";
// import fdata from "./fakedata_mucuge_2021.01.01-2021.06.30";
// import fdata from "./fakedata_baixio_2022.01.01-2022.06.30";
import fdata from "./fakedata_buracao";

import poisfdata from "./fakepoidata_pnme";
// import poisfdata from "./fakepoidata_muritiba";
// import poisfdata from "./fakepoidata_pncd";

const api_wp_ajax_key = process.env.VUE_APP_WP_AJAX_API_KEY
const username = process.env.VUE_APP_WP_USER
const application_password = process.env.VUE_APP_WP_PWD
const api_url_v1 = process.env.VUE_APP_API_JANOO_URL

export default {
  getBillItems(formDate) {

    // return janooApi.get("/orders", {
    //   params: { start_date: formDate.startDate, end_date: formDate.endDate, api_key: api_key, bocapio_key: '395EECC7-3847-11ED-8AB5-F23C9227EC8D' }
    // })
    console.log('>>>>>>>>>USING FAKE DATA<<<<<<<<<<<<<');
    return {data:JSON.parse(fdata.fakedata)}
  },
  getBillItemsAjax(formDate) {
    // func, , deleteItemID
    var _url = "https://janoo.com.br/wp-json/janoo-api/v1/orders?start_date=2022-09-15&end_date=2022-09-29&api_key="+api_wp_ajax_key+"&bocapio_key=395EECC7-3847-11ED-8AB5-F23C9227EC8D";

    // _url = '//apps-dev.bocapio.com.br/products/json/list/?&layout=ajax';
    // console.error(_url);

    return jQuery
      .ajax({
        // type: "GET",
        // url: _url,
        // dataType: "json",
        async: true,
        crossOrigin: "anonymous",
        // crossDomain: true,

        type: "GET",
        // contentType: "application/json; charset=utf-8",
        // async:false,
        url: _url,
        // data: { symbol: 'ctsh' },
        dataType: "jsonp",
        // jsonpCallback: 'fnsuccesscallback'
      })
      .done(function (response, textStatus) {})
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error("Janoo Service:: Erro ao carregar dados do servidor");
        console.log(jqXHR.responseText);
        console.log(textStatus);
        console.log(errorThrown);
      })
      .always(function () { });
  },
  setBillItemAgent(agent_data, billItemID, userID) {
    return janooApi.get("/meta_data", {
      //change meta_value by get_meta=true    to retrieve post metadata
      //change meta_value by delete_meta=true to remove post metadata
      params: { meta_key: 'agent_data', api_key: api_wp_ajax_key, post_id: billItemID, meta_value: agent_data, user_id: userID }
    })
  },
  getUserProductsList() {
    if (process.env.NODE_ENV != "production") {
      return JSON.parse(poisfdata.fakedata)
    }else{
      let janooUserUuid = JSON.parse(localStorage.getItem('cakeuserdata')).place.janooUserUuid || JSON.parse(localStorage.getItem('cakeuserdata')).user.uuid
      return this.getAjax("GET", "get_vendor_pois", janooUserUuid)
    }
  },
  //TODO: fazer a chamada via axios!!! com o janooApi
  getAjax(protocol, endpoint, bocapio_key, postData) {
    return jQuery.ajax({
      type: protocol,
      url: `${api_url_v1}${endpoint}?api_key=${api_wp_ajax_key}&bocapio_key=${bocapio_key}`,
      beforeSend: function (xhr) {
        let token = btoa(username + ':' + application_password)
        xhr.setRequestHeader('Authorization', 'Basic ' + token)
      },
      // data: postData,
      // success:function(response) {
      // }
    });
  }
};
